import React from 'react';
import { motion } from 'framer-motion';
export function Section1() {
  return <motion.section initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.6
  }} viewport={{
    once: true
  }} className="max-w-3xl mx-auto px-6 py-16" data-id="element-16">
      <h2 className="font-sans font-bold text-3xl text-[#0F4226] mb-8" data-id="element-17">
        1. The Ancient Wisdom
      </h2>

      <div className="mb-8" data-id="element-18">
        <img src="https://cdn.magicpatterns.com/uploads/91FBeooKZwEDAyYLoQteaG/Dog_resting_in_202604192244.jpg" alt="Ancient courtyard with dog resting beneath hanging cedar and herb bundles" className="w-full rounded shadow-md" data-id="element-19" />
      </div>

      <div className="font-sans text-lg leading-relaxed text-[#666666] space-y-6" data-id="element-20">
        <p data-id="element-21">
          Picture an Egyptian household in 400 BC. Animals kept in the inner
          courtyard. Cedar branches hanging in the doorways, bundles of
          pennyroyal tucked into the straw bedding, the air faintly sharp with
          the smell of crushed mint-family herbs.
        </p>
        <p data-id="element-22">No fleas. No ticks. No chemicals.</p>
        <p data-id="element-23">This wasn't superstition. This was solved.</p>
        <p data-id="element-24">
          Ancient Egyptians used cedarwood oil extensively — not just for
          embalming, but for its documented insect-repelling properties in
          animal care. The Roman naturalist Pliny the Elder documented
          pennyroyal and wormwood as insect repellents for livestock in{' '}
          <em data-id="element-25">Natural History</em> (77 AD) — specific enough to cite by name and
          date.
        </p>
        <p data-id="element-26">
          Native American tribes used sage, sweetgrass, and cedar to protect
          animals from insects — the smudging practice had documented practical
          pest-control roots alongside spiritual ones. Pre-industrial American
          farmers used pennyroyal oil on collars, lavender in bedding, and
          herbal sachets in animal quarters as standard practice — not folk
          medicine, just common sense.
        </p>
        <p className="text-xl font-medium italic border-l-4 border-[#4DC61A] pl-6 py-4 my-8 bg-[#4DC61A]/10 text-[#0F4226]" data-id="element-27">
          For 2,000 years, across every culture on every continent, humans
          solved this problem the same way. With plants. And it worked.
        </p>
      </div>
    </motion.section>;
}